export default __webpack_public_path__ + "static/media/learn-more-card-5.f7cda43f.svg";